export const dismissNudgeTooltip = "savlNe";
export const prioritizeNudgeTextTemplate = "bdKoec";
export const prioritizeNudgeTextBold = "gmMbB";
export const prioritizeNudgeTextDescription = "hIPSEc";
export const prioritizeNudgeTextDescriptionOnDelivery = "CFZiKc";
export default {dismissNudgeTooltip,prioritizeNudgeTextTemplate,prioritizeNudgeTextBold,prioritizeNudgeTextDescription,prioritizeNudgeTextDescriptionOnDelivery};